export default __webpack_public_path__ + "static/media/windowopen.e58d4e0c.png";